const createPatientCategories = [
    'patientInfo',
    'contactInfo',
    'emergencyContact',
    'insuranceDetails',
    'extraInformation',
];

export default createPatientCategories; 
